import type { ObraInsightConclusion } from '@/lib/obraInsights';

interface Props {
  conclusiones: ObraInsightConclusion[];
  hideFinancial?: boolean;
  className?: string;
}

export function ObraConclusiones({ conclusiones, hideFinancial, className }: Props) {
  const items = hideFinancial ? conclusiones.filter((c) => !c.financial) : conclusiones;
  if (items.length === 0) return null;

  return (
    <div className={`border-t pt-2 space-y-1.5 ${className ?? ''}`}>
      {items.map((c, i) => {
        const toneCls =
          c.tone === 'pos'
            ? 'text-emerald-600'
            : c.tone === 'neg'
            ? 'text-destructive'
            : c.tone === 'warn'
            ? 'text-amber-600'
            : 'text-muted-foreground';
        return (
          <div key={i} className="flex items-start gap-2 text-xs">
            <c.icon className={`h-3.5 w-3.5 mt-0.5 shrink-0 ${toneCls}`} />
            <span className={toneCls}>{c.text}</span>
          </div>
        );
      })}
    </div>
  );
}
